import { BugReportDialog } from 'legacy/docflow/bugReport/BugReportDialog'
import { useState } from 'react'
import { useSelector } from 'react-redux'

import { selectJbpPartnerAccess } from 'clickNgo/helpers/selectors'
import { Translation } from 'cng-common/features/translations'
import { getUrlParam } from 'core-components/helpers/url'
import { Button } from 'core-components/library/button'
import { selectUser } from 'core-components/sitebuilder/store/selectors/selectUser'
import { ProjectManagementIcon } from 'partner360/components/pmIcon/ProjectManagementIcon'

import { UamHpContactRequestEditor } from './components/uamHpContactRequestEditor/UamHpContactRequestEditor'
import { TRANSLATION_KEYS } from './translations'

import styles from './UamAccessDenied.module.scss'

export const UamAccessDenied = () => {
  const [showBugReportDialog, setShowBugReportDialog] = useState(false)
  const [showHpContactDialog, setShowHpContactDialog] = useState(false)

  const user = useSelector(selectUser)
  const jbpPartnerAccess = useSelector(selectJbpPartnerAccess)
  const partnerId = getUrlParam('pid')
  const isRequestInProgress = jbpPartnerAccess.STRequestStatus !== null

  return (
    <div className={styles.uamAccessDenied}>
      <div className={styles.header}>
        <Translation
          text={TRANSLATION_KEYS.greetings}
          replaceParams={[
            {
              key: '{name}',
              value: user.firstName,
            },
          ]}
        />
      </div>
      <div className={styles.warningMessage}>
        <ProjectManagementIcon />
        <Translation text={TRANSLATION_KEYS.warningMessage} />
      </div>
      <div className={styles.message}>
        <Translation text={TRANSLATION_KEYS.requestAccessMessage} />
      </div>
      <div className={styles.footer}>
        <Button onClick={() => setShowBugReportDialog(true)}>
          <Translation text={TRANSLATION_KEYS.support} />
        </Button>
        <Button
          color="success"
          disabled={isRequestInProgress}
          onClick={() => setShowHpContactDialog(!showHpContactDialog)}
        >
          <Translation text={TRANSLATION_KEYS.requestProfile} />
        </Button>
      </div>
      {showBugReportDialog && (
        <BugReportDialog show={true} onClose={() => setShowBugReportDialog(false)} />
      )}

      <UamHpContactRequestEditor
        showRequestAccessDialog={showHpContactDialog}
        setShowRequestAccessDialog={setShowHpContactDialog}
        partnerId={partnerId}
        user={user}
      />
    </div>
  )
}
